import { useEffect } from 'react';
import { useMovimientoCajaWebSocket } from '../context/MovimientoCajaWebSocketContext';

/**
 * Suscribe ``onEvent`` a los eventos del libro de caja de UNA sesión POS
 * explícita. El canal se abre con ``?sesion_id=`` (el backend revalida la
 * autoridad del usuario sobre esa sesión compartida) y se ignoran eventos de
 * otras sesiones.
 */
export const useWebSocketMovimientosCaja = (onEvent: (data: any) => void, sesionId?: number | null) => {
    const { onMovimientoEvent, connectToSession } = useMovimientoCajaWebSocket();

    useEffect(() => {
        if (Number.isInteger(sesionId) && (sesionId as number) > 0) connectToSession(sesionId as number);
    }, [sesionId, connectToSession]);

    useEffect(() => {
        console.log('[useWebSocketMovimientosCaja] Hook registrado');
        const unsub = onMovimientoEvent((data) => {
            if (sesionId && data?.sesion_id !== undefined && Number(data.sesion_id) !== Number(sesionId)) return;
            console.log('[useWebSocketMovimientosCaja] Evento recibido:', data);
            onEvent(data);
        });

        return () => {
            console.log('[useWebSocketMovimientosCaja] Hook limpiado');
            unsub();
        };
    }, [onMovimientoEvent, onEvent, sesionId]);
};

